module.exports = "/packs/course-small-branding-a705feb6dafc2045f00240e5d07eb492.png";